import React from 'react'
import { useNavigate } from 'react-router-dom'
import './PopUp.scss';
import book from '../../Images/book.png'
import bgnobgs from '../../Images/bgnobgs.png'
import closeMenu from '../../Images/closeMenu.png'

export default function PopUp({ setShowPopUp }) {
    const Navigate = useNavigate()
    return (
        <div className="PopUp">
            <div className="MainBanner">
                <div className="MainBannerHeader">
                    <img onClick={() => {
                        localStorage.setItem("showPopUp", true);
                        setShowPopUp(false)
                    }
                    } src={closeMenu} alt="Chimney Sweep In Pomona, CA | Chimney Repair In Pomona, CA | Chimney Services In Pomona, CA | Chimney Inspection In Pomona, CA" />
                </div>
                <div className="MainBannerLeft">
                    <h1>Schedule Your Chimney Service Today!</h1>
                    <h2>Don't wait until it's too late! Ensure your chimney is safe and functioning efficiently.</h2>
                    <a href="tel:951-330-3128" onClick={() => {
                        localStorage.setItem("showPopUp", true);
                        setShowPopUp(false)
                    }}>Click To Call!</a>
                    <a href="/book" onClick={() => {
                        localStorage.setItem("showPopUp", true);
                        setShowPopUp(false)
                    }}>SCHEDULE ONLINE<img src={book} alt="Chimney Cleaning Near Me In Pomona, California" /></a>
                </div>
                <div className="MainBannerRight">
                    <img src={bgnobgs} alt="Chimney Sweep In Pomona, CA | Chimney Repair In Pomona, CA | Chimney Services In Pomona, CA | Chimney Inspection In Pomona, CA" />
                    <div className="MainBannerRightBubble1"></div>
                    <div className="MainBannerRightBubble2"></div>
                </div>
            </div>
        </div>
    )
}
